"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ImageSvgComponent {
    constructor(imageSource, snapCtx, position, dimensions) {
        this.imageSource = imageSource;
        this.snapCtx = snapCtx;
        this.position = position;
        this.dimensions = dimensions;
    }
    draw() {
        return new Promise((resolve, reject) => {
            this.snapCtx.image(this.imageSource, this.position.x, this.position.y, this.dimensions.width, this.dimensions.height);
            resolve();
        });
    }
}
exports.ImageSvgComponent = ImageSvgComponent;
